import React, { useState } from "react";
import API_BASE_URL from "../apiConfig";

export default function TradingPlReport() {
  const [from, setFrom] = useState("2025-04-01");
  const [to, setTo] = useState("2026-03-31");
  const [d, setD] = useState(null);

  const load = async () => {
    const res = await fetch(`${API_BASE_URL}/reports/trading-pl?from=${from}&to=${to}`);
    setD(await res.json());
  };

  return (
    <div style={{ maxWidth: 700, margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: 10 }}>
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={{ marginLeft: 6 }} />
        <button onClick={load} style={{ marginLeft: 6 }}>Go..</button>
      </div>
      <h3 style={{ textAlign: "center" }}>Trading Account</h3>
      {d && (
        <table border="1" cellPadding="6" style={{ width: "100%", borderCollapse: "collapse", marginBottom: 24 }}>
          <tbody>
            <tr><td>Opening Stock</td><td style={{ textAlign: "right" }}>{d.openingStock.toFixed(2)}</td><td>Sales</td><td style={{ textAlign: "right" }}>{d.sales.toFixed(2)}</td></tr>
            <tr><td>Purchase</td><td style={{ textAlign: "right" }}>{d.purchase.toFixed(2)}</td><td>Less Credit Note</td><td style={{ textAlign: "right" }}>{d.creditNote.toFixed(2)}</td></tr>
            <tr><td>Less Debit Note</td><td style={{ textAlign: "right" }}>{d.debitNote.toFixed(2)}</td><td>Closing Stock</td><td style={{ textAlign: "right" }}>{d.closingStock.toFixed(2)}</td></tr>
            <tr style={{ fontWeight: "bold" }}><td>Gross Profit</td><td style={{ textAlign: "right" }}>{d.grossProfit.toFixed(2)}</td><td></td><td></td></tr>
          </tbody>
        </table>
      )}
      {d && (
        <>
          <h3 style={{ textAlign: "center" }}>Profit & Loss Account</h3>
          <table border="1" cellPadding="6" style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody><tr style={{ fontWeight: "bold" }}><td>Net Profit</td><td style={{ textAlign: "right" }}>{d.netProfit.toFixed(2)}</td></tr></tbody>
          </table>
        </>
      )}
      <p style={{ textAlign: "center", fontStyle: "italic", marginTop: 20 }}>*** End of report ***</p>
    </div>
  );
}